<template>
  <a class="folderButton folderButton__btn" @click="setFolderModal">
    <i class="folderButton--icon fas fa-folder" />
  </a>
</template>
<script setup>
import { useStore } from 'vuex'

const store = useStore()

const setFolderModal = () => store.dispatch('modals/setFolderModal')
</script>
<style lang="scss" scoped>
.folderButton {
  color: $blue-80 !important;
  width: 100%;
  &__btn {
    display: flex;
    justify-content: center;
    align-items: center;
    background: $white !important;
    border-radius: 5px;
    padding: 1.25rem;
    width: 0.625rem;
    height: 0.625rem;
    border: 1px solid $black-30;
    box-shadow: 0px 0px 4px $black-30;
    &--icon {
      color: $blue-80 !important;
    }
    &:hover {
      background: $blue-80 !important;
      .folderButton--icon {
        color: $white !important;
      }
    }
  }
}
</style>
